import apiClient from "./apiClient";
const resource = '/guests';

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, {params});
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(uuid, data) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
  // *codingan lama: madhan*
  // async search(keyword) {
  //   return apiClient.get(`${resource}/search?keyword=${keyword}`);
  // },

  // *codingan baru : naldi*
  search(params = {}) {
    return apiClient.get(`${resource}/search`, { params });
  }

};